/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".actions-section[_ngcontent-%COMP%]{border-top:1px solid #dee2e6;justify-content:flex-end}.actions-section[_ngcontent-%COMP%]   button[_ngcontent-%COMP%]{height:35px;width:20%;color:#fff;background-color:#0065b8;border-radius:2px;cursor:pointer;text-transform:uppercase;outline:0}"];
export { styles as styles };
